import { api } from './axios';

export type SmsStatus = 'QUEUED' | 'SENDING' | 'SENT' | 'FAILED';

export interface SmsMessage {
  id: number;
  phoneNumber: string;
  body: string;
  status: SmsStatus;
  attempts: number;
  maxAttempts: number;
  claimedAt: string | null;
  claimedByDeviceId: number | null;
  claimedByDeviceName: string | null;
  sentAt: string | null;
  failedReason: string | null;
  sourceType: string | null;
  sourceId: number | null;
  dedupeKey: string | null;
  createdAt: string;
}

export interface QueueSmsInput {
  phoneNumber: string;
  body: string;
  sourceType?: string;
  sourceId?: number | null;
  dedupeKey?: string;
}

export interface SmsPage {
  content: SmsMessage[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface GatewayDevice {
  id: number;
  deviceName: string;
  active: boolean;
  lastSeenAt: string | null;
  lastBattery: number | null;
  lastSignal: number | null;
  lastSimBalance: string | null;
  createdAt: string;
}

export interface CreatedDevice {
  device: GatewayDevice;
  token: string;
}

export const notificationsApi = {
  // queue
  list: (params: { status?: SmsStatus; page?: number; size?: number }) =>
    api.get<SmsPage>('/notifications/sms', { params }).then((r) => r.data),
  get: (id: number) => api.get<SmsMessage>(`/notifications/sms/${id}`).then((r) => r.data),
  enqueue: (body: QueueSmsInput) =>
    api.post<SmsMessage>('/notifications/sms', body).then((r) => r.data),

  // devices
  listDevices: (activeOnly = false) =>
    api
      .get<GatewayDevice[]>('/notifications/devices', { params: { activeOnly } })
      .then((r) => r.data),
  createDevice: (body: { deviceName: string }) =>
    api.post<CreatedDevice>('/notifications/devices', body).then((r) => r.data),
  renameDevice: (id: number, body: { deviceName: string }) =>
    api.put<GatewayDevice>(`/notifications/devices/${id}`, body).then((r) => r.data),
  setDeviceActive: (id: number, value: boolean) =>
    api
      .patch<GatewayDevice>(`/notifications/devices/${id}/active`, null, { params: { value } })
      .then((r) => r.data),
  rotateDeviceToken: (id: number) =>
    api.post<CreatedDevice>(`/notifications/devices/${id}/rotate-token`).then((r) => r.data),
  deleteDevice: (id: number) =>
    api.delete<void>(`/notifications/devices/${id}`).then((r) => r.data),
};
